import { PROFILE_DETAILS } from "./apiURl";
import { commonHeaders, getRequest, patchRequest } from "./httpHelper";

export const getProfileDetails = async () => {
  try {
    const response = await getRequest({
      url: PROFILE_DETAILS,
      headers: commonHeaders,
    });
    return response.data ? response.data : response;
    // return response;
  } catch (error) {
    // console.error("Error fetching profile details:", error);
    return error;
  }
};

export const updateProfileDetails = async (userId, profileData) => {
  try {
    const url = `${PROFILE_DETAILS}${userId}/`;
    const response = await patchRequest({
      url: url,
      headers: commonHeaders,
      data: profileData,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    return response.data;
  } catch (error) {
    console.error("Error updating profile details:", error);
    return null;
  }
};


